import React from 'react';
import AllOrders from '../allOrders/AllOrders';

const AdminRejectedParcels = () => {
	return <AllOrders admin title='All Rejected Parcels' isRejected />;
};

export default AdminRejectedParcels;
